import { render } from "./TextReplace.vue?vue&type=template&id=45a237f7&scoped=true"
import script from "./TextReplace.vue?vue&type=script&lang=js"
export * from "./TextReplace.vue?vue&type=script&lang=js"

import "./TextReplace.vue?vue&type=style&index=0&id=45a237f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a237f7"]])

export default __exports__